import { render, staticRenderFns } from "./skxRzsx.vue?vue&type=template&id=e2b07002&scoped=true&"
import script from "./skxRzsx.vue?vue&type=script&lang=js&"
export * from "./skxRzsx.vue?vue&type=script&lang=js&"
import style0 from "./skxRzsx.vue?vue&type=style&index=0&id=e2b07002&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b07002",
  null
  
)

export default component.exports